import crmAgreementPriceIncrease from './crm-agreement-price-increase';
import crmPartner from './crm-partner';
import bankingOperations from './crm/banking-operations';
import billing from './crm/billing';
import crmMails from './crm/crm-mails';
import mailGroups from './crm/mail-groups';
import mailTemplates from './crm/mail-templates';
import invoice from './invoice';
import partnerStaff from './partner-staff';
import partnerStaffBoardMember from './partner-staff-board-member';
import leaves from './staff/leaves';
import vehicles from './staff/vehicles';
import zusWarning from './zus-warning';

export default {
  billing,
  bankingOperations,
  crmAgreementPriceIncrease,
  crmPartner,
  invoice,
  leaves,
  vehicles,
  crmMails,
  mailGroups,
  mailTemplates,
  partnerStaff,
  partnerStaffBoardMember,
  zusWarning,
};
